export const GET_FAQ_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    faq(id: "${id}", preview: ${preview}) {
      question
      answer {
        json
        links {
          entries {
            hyperlink {
              ... on Page {
                  sys {id}
                  slug
                  content {
                  __typename
                  }
              }
              ... on FileBlock {
                  sys {id}
                  imageVaultFile
                  metaData
                  __typename
              }
            }
          }
        }
      }
        contentfulMetadata {
        concepts {
          id
        }
      }
      audienceCollection{
        items{
            __typename
            sys{id}
            audianceId
          }
      }
    }
  }
`;
